module.exports = require("@wordpress/date");